/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_OnrXmvidK",
    "aws_user_pools_web_client_id": "1jp28doh2eu5t1j38io9braja",
    // "aws_cognito_identity_pool_id": "us-west-2:fada5186-3c8d-4f25-af40-16e9d4b8039b",
    "oauth": {
        "domain": "appe7f40576-e7f40576-sou.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:8090/",
        "redirectSignOut": "",
        "responseType": "code"
    },
    // "federationTarget": "aeru_werservice_admin"
};


export default awsmobile;

